/**
 * Набор вспомогательных директив для компонентов.
 */

import Vue from "vue";

/**
 * Директива которая позволяет отследить клики мышкой (событие `click`) за пределами указанного компонента (тега и его вложенных тегов).
 * При появлении такого события вызовется функция, переданная в директиве.
 *
 * Необходимо обеспечить распространение события клика чтобы отследить его источник и удостоверится, что
 * вызывать метод следует только непосредственно для своего компонента. Это важно в случае если мы используем
 * несколько компонентов и у всех имеется эта директива, в таком случае метод сработает для всех компонентов,
 * кроме того на котором был совершен клик.
 *
 * Директива по умолчанию будет навешивать прослушивание кликов на всем body, однако не следует забывать что некоторые элементы
 * могут останавливать распространение событий. Так делает и сам vue https://github.com/vuejs/vue/issues/6566
 * и данная ситуация актуальна для случаев кликов внутри модальных окон vuedals, при том что снаружи их (на затемненном фоне)
 * события продолжают отслеживаться.
 * Потому есть такой костыль - прослушиваются клики на body и на элементах с классом `js-click-outside`, который рекомендуется
 * устанавливать на модальные окна.
 *
 * В качестве значения принимается функция, которая вызовется при клике за пределами элемента и его вложенных тегов.
 *
 * Обработка (навешивание обработчиков) происходит в хуке директивы `inserted`, а не `bind`. Причина - если директива применяется
 * на модальных окнах (на еще не отрисованных элементах), то она срабатывает только на теге body. Хук inserted сработает после отрисовки.
 */
Vue.directive("click-outside", {
  inserted(el, binding) {
    el._outsideClickEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };

    el._elementsWithListener = [document.body, ...document.querySelectorAll(".js-click-outside")];
    el._elementsWithListener.forEach((elementForListening) => {
      elementForListening.addEventListener("click", el._outsideClickEvent);
    });
  },
  unbind(el) {
    el._elementsWithListener.forEach((elementForListening) => {
      elementForListening.removeEventListener("click", el._outsideClickEvent);
    });
  },
});
